module.exports = __webpack_public_path__ + "static/media/popup-surface.857a0048.png";